<template>
  <div id="paymentTrackingModal" class="modal fade" role="dialog">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="addBillingPayment" class="modal-content row">
        <div class="modal-header row col-md-10 col-md-offset-1">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h3 class="modal-title font-blue col-md-10 col-md-offset-1">Encaissement</h3>
        </div>
        <div class="modal-body col-md-10 col-md-offset-1">
          <br>
          <div class="row">
            <div class="col-xs-4 table-currency">
              <span class="label label-total-paid">Total facturé :</span>
              <span :class="paidLabelColor">Reste à encaisser :</span>
            </div>
            <div class="col-xs-4 table-currency">
              <h3>{{ totalBillingPrice.toFixed(2) }} &euro;</h3>
              <h3>{{ totalLeftToPaid.toFixed(2) }} &euro;</h3>
            </div>
          </div>
          <div class="form-group mt-repeater" v-for="(payment, index) in paymentList" :key="index">
            <button type="button" class="btn btn-danger delete-button" @click.prevent="removeSinglePayment(payment)">
              <i class="fas fa-times"></i>
            </button>
            <div class="row" :class="payment.deleted ? 'deleteBilling' : ''">
              <div class="form-group form-2-col">
                <label>Date *</label>
                <input-date v-model="payment.date" name="date" class="form-control datepicker" :disabled="payment.disable" required />
              </div>
              <div class="form-group  form-2-col">
                <label>Modalité de paiement:</label>
                <select class="form-control" name="typePaiement" v-model="payment.payment_method_id" :disabled="payment.disable">
                  <option v-for="method in paymentMethods" :value="method.id" :key="method.id">{{ method.name }}</option>
                </select>
              </div>

              <div class="col-md-3">
                <div class="form-group mt-repeater-input">
                  <label>Montant *</label>
                  <input class="form-control" placeholder="Ex : 15.30" type="number" step="0.01" min="0"
                         name="amount" v-model="payment.amount" :disabled="payment.disable" required/>
                </div>
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-success" @click.prevent="addSinglePayment">
            Ajouter un paiement <i class="fa fa-plus"></i>
          </button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Quitter</button>
          <input v-if="displaySaveButton" type="submit" class="btn green" value="Sauvegarder"/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { usefulMethodsMixin } from '../mixins/useful-methods-mixin'
import Datepicker from 'vuejs-datepicker'

export default {
  name: "billingPaymentTracking",
  mixins : [usefulMethodsMixin],
  data(){
    return {
      paymentList : [],
      payment : {
        date: '',
        amount : '',
        billing_id : '',
        payment_method_id : '',
      },
      paymentMethods : [],
      totalBillingPrice : 0, //billing initial price
    }
  },
  created() {
    globalEventBus.$on('selectedBillingforPaymentTracking', async billingId => {
      this.payment.billing_id = billingId;

      try {
        const response = await axios.get('/billingpayment/billingpaymenttracking/' + billingId);
        let data = response.data;

        this.paymentList = (data.paymentList !== null) ? data.paymentList.filter(p => !p.deleted) : [];
        this.totalBillingPrice = data.totalBillingPrice;
        this.paymentMethods = data.paymentMethod;

        // Convertir le format de la date pour chaque paiement
        this.paymentList.forEach(payment => {
          if (!payment.date) {
            console.log("Date manquante pour le paiement:", payment);
          }

          payment.date = this.formatDateForDatepicker(payment.date);

          if (!payment.date) {
            console.log("Conversion de date échouée pour le paiement:", payment);
          }
        });

        console.log(this.paymentList);
      } catch (error) {
        console.log(error);
      }
    });
  },
  methods : {
    addSinglePayment() {
      let tempPayment = JSON.parse(JSON.stringify(this.payment))

      this.paymentList.push(tempPayment)

      this.payment = {
        date: '',
        amount : '',
        billing_id : tempPayment.billing_id,
        payment_method_id : '',
      }
    },
    removeSinglePayment(payment) {
      if(payment.id){
        axios.delete('/billingpayment/billingpaymenttracking/' + payment.id)
          .then(response => this.paymentList.splice(this.paymentList.indexOf(payment), 1))
          .catch(error => console.log(error))
      } else {
        this.paymentList.splice(this.paymentList.indexOf(payment), 1)
      }
    },
    addBillingPayment() {
      // Convertir le format de la date pour chaque paiement avant de l'envoyer
      const formattedPayments = this.paymentList.map(payment => {
        const newPayment = { ...payment };
        newPayment.date = this.formatDateForDatabase(payment.date);
        return newPayment;
      });

      axios.post('/billingpayment/billingpaymenttracking', formattedPayments)
        .then(response => {
          //close modal
          $('#paymentTrackingModal').modal('hide');
        }).catch(error => {
        console.log(error)
      });
    },
    formatDateForDatepicker(isoDate) {
      if (!isoDate) {
        return ''; //
      }
      const date = new Date(isoDate);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois sont de 0 à 11
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
  },
  computed : {
    totalLeftToPaid : function () {
      return this.sumKey(this.paymentList, 'amount') > 0 ?  this.totalBillingPrice - this.sumKey(this.paymentList, 'amount') : this.totalBillingPrice
    },
    paidLabelColor : function () {
      return (this.sumKey(this.paymentList, 'amount') >= 0 && this.sumKey(this.paymentList, 'amount') < this.totalBillingPrice)
        ? 'label label-danger' : 'label billingSuccess'
    },
    displaySaveButton : function () {
      return this.paymentList.find(function(element) {
        return element.id === undefined
      });
    }
  },
  watch: {
    'payment.date': function(newValue) {
      if (!newValue) {
        console.log("La date est invalide ou manquante!");
      }
    }
  },
  components : {
    Datepicker
  }
}
</script>

<style scoped>
.label {
  display: block;
  text-align: left;
}

.label-total-paid {
  background-color: #00D095;
}

.table-currency > * + *{
  margin-top: 10px !important;
}

.table-currency > * {
  margin: 4px 0;
  padding: 3px 6px 3px 6px;
  line-height: 18px;
}

.delete-button {
  float: right;
  padding: 8px 16px;
  font-size: 30px;
  background-color: #F29BA2;
  border-color: #F29BA2;
}

.delete-button .fa-times {
  color: white;
}

.green {
  background-color: #29D7A5;
}

.modal-body .row {
  margin-bottom: 20px;
}
</style>
